import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { for: "daysWeek" }
const _hoisted_2 = { class: "row justify-content-around" }
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t("group.fields.weekDays")), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
        return (_openBlock(), _createElementBlock("div", {
          key: day.value,
          class: "checkdiv d-flex align-items-center flex-column"
        }, [
          _createVNode(_component_Checkbox, {
            inputId: day.name,
            id: day.name,
            name: day.name,
            value: day.value,
            label: day.label,
            modelValue: _ctx.selectedDays,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDays) = $event)),
            disabled: _ctx.disabled,
            onChange: _ctx.getSelectedDays
          }, null, 8, ["inputId", "id", "name", "value", "label", "modelValue", "disabled", "onChange"]),
          _createElementVNode("label", {
            class: "checkLabel",
            for: day.name
          }, _toDisplayString(day.label), 9, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}